import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { cn } from "$lib/utils.js";

var root = $.from_html(`<label><!></label>`);

export default function Label($$anchor, $$props) {
	$.push($$props, true);

	let ref = $.prop($$props, 'ref', 15, null),
		restProps = $.rest_props($$props, [
			'$$slots',
			'$$events',
			'$$legacy',
			'ref',
			'class',
			'children'
		]);

	var label = root();

	$.attribute_effect(label, ($0) => ({ 'data-slot': 'label', class: $0, ...restProps }), [
		() => cn("flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50", $$props.class)
	]);

	var node = $.child(label);

	$.snippet(node, () => $$props.children ?? $.noop);
	$.reset(label);
	$.bind_this(label, ($$value) => ref($$value), () => ref());
	$.append($$anchor, label);
	$.pop();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsibGFiZWwuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG5cdGltcG9ydCB7IGNuIH0gZnJvbSBcIiRsaWIvdXRpbHMuanNcIjtcblx0aW1wb3J0IHR5cGUgeyBIVE1MTGFiZWxBdHRyaWJ1dGVzIH0gZnJvbSBcInN2ZWx0ZS9lbGVtZW50c1wiO1xuXHRpbXBvcnQgdHlwZSB7IFNuaXBwZXQgfSBmcm9tICdzdmVsdGUnO1xuXG5cdGxldCB7XG5cdFx0cmVmID0gJGJpbmRhYmxlKG51bGwpLFxuXHRcdGNsYXNzOiBjbGFzc05hbWUsXG5cdFx0Y2hpbGRyZW4sXG5cdFx0Li4ucmVzdFByb3BzXG5cdH06IEhUTUxMYWJlbEF0dHJpYnV0ZXMgJiB7IHJlZj86IEhUTUxMYWJlbEVsZW1lbnQgfCBudWxsOyBjaGlsZHJlbj86IFNuaXBwZXQgfSA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG5cbjxsYWJlbFxuXHRiaW5kOnRoaXM9e3JlZn1cblx0ZGF0YS1zbG90PVwibGFiZWxcIlxuXHRjbGFzcz17Y24oXG5cdFx0XCJmbGV4IGl0ZW1zLWNlbnRlciBnYXAtMiB0ZXh0LXNtIGxlYWRpbmctbm9uZSBmb250LW1lZGl1bSBzZWxlY3Qtbm9uZSBncm91cC1kYXRhLVtkaXNhYmxlZD10cnVlXTpwb2ludGVyLWV2ZW50cy1ub25lIGdyb3VwLWRhdGEtW2Rpc2FibGVkPXRydWVdOm9wYWNpdHktNTAgcGVlci1kaXNhYmxlZDpjdXJzb3Itbm90LWFsbG93ZWQgcGVlci1kaXNhYmxlZDpvcGFjaXR5LTUwXCIsXG5cdFx0Y2xhc3NOYW1lXG5cdCl9XG5cdHsuLi5yZXN0UHJvcHN9XG4+e0ByZW5kZXIgY2hpbGRyZW4/LigpfTwvbGFiZWw+XG4iXSwibWFwcGluZ3MiOiI7O1NBQ1UsRUFBRSxRQUFRLGVBQWU7Ozs7aURBRG5DLENBQUM7OztLQU1DLEdBQUcsOEJBQWEsSUFBSTtFQUdqQixTQUFTOzs7Ozs7Ozs7OzswRUFXVCxTQUFTO1FBSk4sRUFBRSxDQUNSLHFOQUFxTjs7Ozs7OztpQ0FIM00sR0FBRyxpQkFBSCxHQUFHOzs7QUFIaEIsQ0FBQyJ9